<template>
  <div class="empadronamiento__intro__main__form__container-item" :class="(value != null && value != '') ? 'fieldFocused':''">
    <label>{{placeholder}}</label>
    <select
      :value="value"
      @input="$emit('input', $event.target.value)"
      class="empadronamiento__intro__main__form__container-form"
      :disabled="disabled"
      :class="{'has-error': invalid}"
    >
      <template v-for="(valueDefault, idx) in valuesDefaults">
        <option v-if="value === valueDefault" :key="`${value}-${idx}`" :value="valueDefault" disabled ref="placeholder" selected>{{ placeholder }}</option>
      </template>

      
      <option style="text-transform:capitalize;" v-for="(option, i) in options" :value="option[prop]" :key="i+1" :selected="value == option[prop]">{{option.Name}}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: [Object, String, Number],
    prop: {
      type: String,
      default: "Id"
    },
    placeholder: String,
    options: [Array, Object],
    disabled: Boolean,
    invalid: Boolean
  },
  data() {
    return {
      valuesDefaults: [0, '', undefined, null]
    }
  },
  computed: {
    optionsLength() {
      if (!this.options) return false;
      return this.options.length;
    }
  },
  watch: {
    optionsLength(newValue) {
      if (newValue === 1) this.$emit("input", this.options[0][this.prop]);
    }
  }
};
</script>
